import { useFeatureFlags } from 'front-end/src/app/hooks/useFeatureFlags'
import { useMemo } from 'react'

export const useRequiredField = (): 'email' | 'account_name' => {
  const { featureFlags } = useFeatureFlags()
  return useMemo(
    () => (featureFlags?.account_name_login ? 'account_name' : 'email'),
    [featureFlags?.account_name_login]
  )
}
